<form class="mobile-view">
  <header class="header">
    <span class="iconfont-arrow-left back" @click="goBack"></span>
    <div class="heading-primary">{{ isEdit ? $t('my_account.addresses.edit_address') : $t('my_account.addresses.add_address') }}</div>
  </header>
  <div class="content address-form">
    <AddressForm
      ref="formRef"
      v-model="currentAddress"
      v-model:isDirty="isDirty"
      v-model:isComplete="isComplete"
      :errors="errors[addressType || 'delivery_address']"
      @clearField="clearErrorField"
    />
  </div>
  <footer class="footer">
    <button
      type="submit"
      name="submit"
      :disabled="!canSave"
      @click.prevent="saveAddress"
      class="b b-A checkout-v2-btn"
    >
      {{ $t('shopping.basket.checkout.save') }}
    </button>
    <button
      v-if="isEdit"
      class="b b-C btn-delete"
      @click.prevent="showDeleteConfirm = true"
    >
      <span class="iconfont-trash"></span>
    </button>
  </footer>
  <NBConfirmModal
    v-model="showDeleteConfirm"
    @confirm="confirmDeleteAddress"
    :confirm-text="$t('app.cart.button_text')"
    :message="$t('messages.user.alert.user_addresses.text')"
    :title="$t('messages.user.alert.user_addresses.headline')"
  />
  <div class="pp-in wait" v-if="pending"></div>
</form>
